// src/utils/permissions.js

/**
 * Does this permission list satisfy `requiredPermission`?
 *
 * There is deliberately no blanket grant here. This helper previously treated
 * `manage_roles` as all-access, which meant anyone who could administer roles
 * also saw payments, expenses and project financials -- the exact leak the
 * role-based dashboards exist to close. Superusers are handled server-side by
 * User.has_permission, which returns True for them.
 */
export const hasPermission = (permissionList, requiredPermission) => {
  if (!requiredPermission) return true;
  const permissions = permissionList || [];
  return permissions.some((p) => p.codename === requiredPermission);
};
